import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import { get } from 'lodash-es';
import BaseFoundation from '../base/foundation';
export default class ModalFoundation extends BaseFoundation {
  constructor(adapter) {
    super(_Object$assign({}, adapter));

    this.toggleHidden = hidden => {
      this._adapter.toggleHidden(hidden);
    }; // eslint-disable-next-line max-len


    this.mergeMotionProp = (motion, prop, cb) => {
      const mergedMotion = typeof motion === 'undefined' || motion ? _Object$assign(_Object$assign({}, motion), {
        [prop]: function () {
          const curr = get(motion, prop);

          if (typeof curr === 'function') {
            curr(...arguments);
          }

          cb();
        }
      }) : false;
      return mergedMotion;
    };
  }

  destroy() {
    this.afterHide();
  }

  handleCancel(e) {
    this._adapter.notifyCancel(e);
  }

  handleOk(e) {
    this._adapter.notifyOk(e);
  }

  beforeShow() {
    this._adapter.disabledBodyScroll();
  }

  afterHide() {
    this._adapter.enabledBodyScroll();
  }

  afterClose() {
    this._adapter.notifyClose();
  }

  getMergedMotion() {
    var _context, _context2;

    let {
      motion
    } = this._adapter.getProps();

    const {
      keepDOM
    } = this._adapter.getProps();

    motion = this.mergeMotionProp(motion, 'didLeave', _bindInstanceProperty(_context = this.afterClose).call(_context, this));

    if (!keepDOM) {
      return motion;
    }

    const mergedMotion = this.mergeMotionProp(motion, 'didLeave', _bindInstanceProperty(_context2 = this.toggleHidden).call(_context2, this, true));
    return mergedMotion;
  }

}